import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { MultiselectCheckmarkComponent, MultiselectGroupCheckmarkComponent, MultiselectHostComponent, MultiselectOpenableButtonComponent } from './components';
import { DropdownMenuModule } from '@anecdotes/design-system/dropdown-menu';
import { LoadersModule } from '@anecdotes/design-system/loaders';
import { FormControlsModule } from '@anecdotes/design-system/form-controls';
import { ButtonsModule } from '@anecdotes/design-system/buttons';
import { SvgIconsModule } from '@anecdotes/design-system/svg-icons';
import { OverlayModule } from '@angular/cdk/overlay';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectivesModule } from '@anecdotes/design-system/directives';

@NgModule({
  declarations: [
    MultiselectHostComponent,
    MultiselectCheckmarkComponent,
    MultiselectOpenableButtonComponent,
    MultiselectGroupCheckmarkComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    DropdownMenuModule,
    LoadersModule,
    FormControlsModule,
    ButtonsModule,
    SvgIconsModule,
    FormsModule,
    OverlayModule,
    NgbTooltipModule,
    DirectivesModule,
  ],
  exports: [
    MultiselectHostComponent,
    MultiselectCheckmarkComponent,
    MultiselectOpenableButtonComponent,
    MultiselectGroupCheckmarkComponent,
  ],
})
export class MultiselectModule {}
